@if (this.shouldShowTopBar$ | async) {
<rs-top-bar-menu
  [menuItems]="this.menuItems()"
  application="MGT"
/>
}

<rs-loader />

<router-outlet />

<rs-footer />